import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const sessionId = m ? decodeURIComponent(m[1]) : null;
        if (!sessionId) throw new Error("No session_id");
        let referralCode = null;
        try {
          referralCode = window.localStorage.getItem("tradingox_ref_code");
        } catch (err) { console.debug("[AuthCallback] localStorage read failed", err); }
        const data = await authApi.session(sessionId, referralCode);
        try { window.localStorage.removeItem("tradingox_ref_code"); } catch (err) { console.debug("[AuthCallback] localStorage clear failed", err); }
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090A0F] text-slate-300">
      <div className="font-mono text-xs uppercase tracking-[0.3em]">Establishing session…</div>
    </div>
  );
}
